module.exports = __webpack_public_path__ + "img/wizard_video1.192fecfe.png";